var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"root-spinner",class:{
    'theme-purple': _vm.theme === 'purple',
    'theme-green': _vm.theme === 'green',
    'theme-red': _vm.theme === 'red',
    'theme-dark': _vm.theme === 'dark',
    'theme-light': _vm.theme === 'light'
  },style:({'font-size': (_vm.size + "px")})},[_c('div'),_c('div'),_c('div'),_c('div')])}
var staticRenderFns = []

export { render, staticRenderFns }